import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NameFilterPipe } from './name-filter.pipe';
import { OrderByPipe } from './order-by.pipe';
import { TranslatePipe } from './translate.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    FormsModule, NameFilterPipe, OrderByPipe, TranslatePipe
  ],
  declarations: [NameFilterPipe, OrderByPipe, TranslatePipe]
})
export class SharedModule { }
